import { createRouter, createWebHistory } from 'vue-router'

import Home from '@/components/pages/Home/Index.vue';
import ProductsLayout from '@/components/pages/Products/Index.vue';
import ProductIndex from '@/components/pages/Product/Index.vue'
import AboutIndex from '@/components/pages/About/Index.vue';
import PrivacyIndex from '@/components/pages/Privacy/Index.vue';
import Login from '@/components/pages/Auth/Login.vue';
import Register from '@/components/pages/Auth/Register.vue';
import VerifyEmail from '@/components/pages/Auth/VerifyEmail.vue';
import ForgotPassword from '@/components/pages/Auth/ForgotPassword.vue';
import ResetPassword from '@/components/pages/Auth/ResetPassword.vue';
import Account from '@/components/pages/Account/Index.vue';
import LearningIndex from '@/components/pages/Learning/Index.vue';
import ContactIndex from '@/components/pages/Contact/Index.vue';
import CheckoutIndex from '@/components/pages/Checkout/Index.vue';
import BookCheckoutIndex from '@/components/pages/BookCheckout/Index.vue';
import { useAuth } from '@/composables/useAuth';
import BooksLayout from '@/components/pages/Books/Index.vue';
import Dashboard from '@/components/pages/Dashboard/Index.vue';

const { isAuthenticated, getUser } = useAuth();
const { logout } = useAuth();

const requireAuth = (to, from, next) => {
    getUser().
        then(() => {
            if (isAuthenticated()) {
                next();
            } else {
                next({ name: 'login' });
            }
        })
        .catch(() => {
            next({ name: 'login' });
        });
}

const redirectIfAuthenticated = (to, from, next) => {
    getUser()
        .then(() => {
            if (isAuthenticated()) {
                next({ name: 'home' });
            } else {
                next();
            }
        })
        .catch(() => {
            next();
        });
}

const handleLogout = async (to, from, next) => {
    await logout();
    next({ name: 'home' });
};

const routes = [
  { path: '/', component: Home, name: 'home' },
  { path: '/login', component: Login, name: 'login', beforeEnter: redirectIfAuthenticated },
  { path: '/register', component: Register, name: 'register', beforeEnter: redirectIfAuthenticated },
  { path: '/logout', name: 'logout', beforeEnter: handleLogout },
  { path: '/verify-email', component: VerifyEmail, name: 'verify-email', beforeEnter: redirectIfAuthenticated },
  { path: '/forgot-password-request', component: ForgotPassword, name: 'forgot-password-request', beforeEnter: redirectIfAuthenticated },
  { path: '/reset-password', component: ResetPassword, name: 'reset-password', beforeEnter: redirectIfAuthenticated },
  { path: '/account', component: Account, name: 'account', beforeEnter: requireAuth },
  { path: '/learning', component: LearningIndex, name: 'learning', beforeEnter: requireAuth },
  { path: '/courses', component: ProductsLayout, name: 'courses' },
  { path: '/books', component: BooksLayout, name: 'books' },
  { path: '/books/:id/checkout', component: BookCheckoutIndex, name: 'books.checkout', beforeEnter: requireAuth },
  { path: '/courses/:slug', component: ProductIndex, name: 'course' },
  { path: '/about-us', component: AboutIndex, name: 'about-us' },
  { path: '/privacy-policy', component: PrivacyIndex, name: 'privacy-policy' },
  { path: '/contact-us', component: ContactIndex, name: 'contact-us' },
  { path: '/dashboard', component: Dashboard, name: 'dashboard', beforeEnter: requireAuth },
  { path: '/courses/:slug/checkout', component: CheckoutIndex, name: 'checkout', beforeEnter: requireAuth },
//   { path: '/payments/paypal/success', component: PaymentSuccess, name: 'payments.success' },
//   { path: '/payments/paypal/cancel', component: PaymentCancel, name: 'payments.cancel' }
]

export default createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ el: to.hash, behavior: 'smooth' });
        }, 150);
      });
    }

    return { top: 0 };
  },
})